var styles = {"box":"Row_box_ar1az_1","relative":"Row_relative_ar1az_7","with-gap":"Row_with-gap_ar1az_10"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
